import React from "react";
import {observable} from "mobx";
import {Provider} from "mobx-react";
import {Env} from "@morningtrain/helpers";
import {Operation} from "@morningtrain/resources";
import {OperationsContext} from "@morningtrain/react-resources";
import {can} from "../conditionals/Can";
import AuthContext from "../contexts/AuthContext";

export default class AuthService extends React.Component {

    static contextType = OperationsContext;

    @observable user = new Map();
    @observable permissions = [];

    static get defaultProps() {
        return {
            refreshAuthOnUnauthorized: true,
            refreshAuthOnForbidden: true,
            reloadPageOnUnauthorized: false,
        }
    }

    constructor(props) {
        super(props);

        this.reload();
    }

    componentDidMount() {
        this.operations.onCreate(operation => {

            operation.beforeExecute(({request, route}) => {
                return new Promise((resolve, reject) => {
                    if (can(route)) {
                        resolve(request);
                    } else {
                        reject({});
                    }
                });
            });

            operation.onError(error => {

                if(error.response && error.response.status) {


                    if(error.response.status === 401 && this.props.reloadPageOnUnauthorized === true) {
                        window.location.reload();
                        return;
                    }

                    if(error.response.status === 401 && this.props.refreshAuthOnUnauthorized === true) {
                        this.refresh();
                    }

                    if(error.response.status === 403 && this.props.refreshAuthOnForbidden === true) {
                        this.refresh();
                    }
                }

                return error;
            });
        });
    }

    get id (){
        return this.user.get('id');
    }

    get operations() {
        return this.context;
    }

    is(id, user_id = null) {

        if (user_id === null) {
            user_id = this.id;
        }

        if (Array.isArray(id)) {
            return id
                .map(id => `${id}`)
                .includes(`${user_id}`);
        }

        return `${user_id}` === `${id}`;
    }

    reload() {
        this.user.replace(Env.get('user', {}));
        this.permissions.replace(Env.get('user_permissions', []));
    }

    refresh() {

        const refreshRoute = Env.get('auth.refresh_route', 'auth.login.refresh');

        return Operation.fromRoute(refreshRoute)
            .execute()
            .then(data => {
                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data.csrf || null;

                if (data.csrf) {
                    document.querySelector('meta[name="csrf-token"]').setAttribute('content', data.csrf);
                }

                Env.set('user', data.user || null);
                Env.set('user_permissions', data.user_permissions || null);
                this.reload();
            })
            .catch(err => {

                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = null;
                Env.set('user', null);
                Env.set('user_permissions', null);
                this.reload();

            });
    }

    can(permission) {
        return this.permissions.includes(permission);
    }

    check() {
        return this.user.size !== 0;
    }

    render() {
        return (
            <AuthContext.Provider value={this} >
                <Provider auth={this}>
                    <React.Fragment>
                        {this.props.children}
                    </React.Fragment>
                </Provider>
            </AuthContext.Provider>
        );
    }

}
